/**
 * ═══════════════════════════════════════════════════════════════
 *  简 → 繁
 * ═══════════════════════════════════════════════════════════════
 *
 * 🔴 **这是字形转换，不是翻译。**
 *    它把页面上的简体字换成繁体字形，再顺手把几个两岸叫法差太远的词
 *    换成台湾的说法（网络→網路、默认→預設…）。**不做语法和语气的本地化。**
 *
 * 🔴 **为什么是 DOM 层转换，不是给每句话包一个 `t()`。**
 *    这个站有 60 多个页面、几千条中文字面量，逐句包一遍是一次几十个文件的
 *    大改，而且以后每加一句话都得记得包 —— 漏一句就是半句简体半句繁体。
 *    DOM 层转换只有一个入口，新加的文案自动就转了。
 *
 * ⚠️ **一简对多繁必须先按词判，再按字判。** 「以后」是「以後」，
 *    「皇后」还是「皇后」；「干净」是「乾淨」，「干什么」是「幹什麼」。
 *    只按字转的话必然出错，所以 `PHRASES` 在前、`CHARS` 在后。
 *
 * ⚠️ **不碰用户正在输入的东西**：`<input>` / `<textarea>` / `contenteditable`
 *    里的值一律不动 —— 转了的话他打一个字就被改一个字，根本没法填表。
 */

/* ─────────────────────── 词 ─────────────────────── */

/**
 * 先按词转，处理两类：
 * ① **一简对多繁的消歧**（后/干/里/发/系/汇/游…）——按字转必错的那些；
 * ② **两岸叫法不同的词**——照字转虽然不错，但台湾人看着别扭。
 *
 * ⚠️ 只收**这个站真的会出现**、而且台湾说法明确的词。
 *    拿不准的一律不收：错译比没译更糟，用户会以为系统在乱改他的数据。
 */
const PHRASES: [string, string][] = [
  // ── 一简对多繁：按字转会错的 ──
  ["皇后", "皇后"],
  ["干净", "乾淨"],
  ["干燥", "乾燥"],
  ["干货", "乾貨"],
  ["公里", "公里"],
  ["里程", "里程"],
  ["万里", "萬里"],
  ["头发", "頭髮"],
  ["理发", "理髮"],
  ["关系", "關係"],
  ["联系", "聯繫"],
  ["系数", "係數"],
  ["汇总", "彙總"],
  ["汇编", "彙編"],
  ["日历", "日曆"],
  ["台历", "檯曆"],
  ["游泳", "游泳"],
  ["上游", "上游"],
  ["下游", "下游"],
  ["游走", "游走"],
  ["冲抵", "沖抵"],
  ["冲销", "沖銷"],
  ["冲洗", "沖洗"],
  ["制作", "製作"],
  ["制造", "製造"],
  ["复制", "複製"],
  ["复选", "複選"],
  ["复杂", "複雜"],
  ["重复", "重複"],
  ["标签", "標籤"],
  ["面条", "麵條"],
  ["一只", "一隻"],
  ["几只", "幾隻"],
  ["手表", "手錶"],
  ["钟表", "鐘錶"],
  ["周围", "周圍"],
  ["四周", "四周"],
  ["松树", "松樹"],
  ["放松", "放鬆"],
  ["轻松", "輕鬆"],
  ["蓬松", "蓬鬆"],

  ["周期", "週期"],
  ["每周", "每週"],
  ["周报", "週報"],
  ["咨询", "諮詢"],
  ["注册", "註冊"],
  ["备注", "備註"],
  ["注明", "註明"],
  ["注释", "註釋"],
  ["标注", "標註"],
  ["注解", "註解"],
  ["批准", "批准"],
  ["准许", "准許"],
  ["准予", "准予"],
  ["游客", "遊客"],
  ["旅游", "旅遊"],
  ["范围", "範圍"],
  ["规范", "規範"],

  // ── 两岸叫法 ──
  ["网络", "網路"],
  ["信息", "資訊"],
  ["默认", "預設"],
  ["登录", "登入"],
  ["注销", "登出"],
  ["搜索", "搜尋"],
  ["短信", "簡訊"],
  ["质量", "品質"],
  ["屏幕", "螢幕"],
  ["数据", "資料"],
  ["视频", "影片"],
  ["在线", "線上"],
  ["离线", "離線"],
  ["打印", "列印"],
  ["软件", "軟體"],
  ["硬件", "硬體"],
  ["设备", "裝置"],
  ["缓存", "快取"],
  ["服务器", "伺服器"],
  ["用户名", "帳號"],
  ["视频", "影片"],
  ["博客", "部落格"],
  ["支付宝", "支付寶"],
  ["微信", "微信"],
];

/* ─────────────────────── 字 ─────────────────────── */

/**
 * 逐字映射。上下两串**必须等长**，第 i 个字一一对应。
 *
 * ⚠️ 写成两串而不是 `{ "简": "繁" }` 是为了体积：几百条对象字面量在打包后
 *    比两串字符大好几倍，而这段代码是**每个页面都要加载**的。
 * ⚠️ 只收简繁**确实不同**的字。相同的字进来只会白占体积。
 */
const S =
  "与专业东丢两个为乐买争亏仅从们价优会传体余侧儿关内册写决净减几则刚创删别办务动劳区华单卖卧卫厅压厨参双变号启员响团围图圣坏墙处备够头宝实审对导将尝层属师带并库应废开异张强归当录" +
  "径态总恶户执扫抢报拦择挂挡换据数无时显晒暂机权条来极柜标树样楼槛橱洁洒浏润涨满滤灯点热状独现电盖盗码砖础确离种积称税稳笔筛简类纠红约级纯纳纷线组细织终经绑结给络绝统继续维绿缓编" +
  "缴网罗联脑艺节获营蓝补装见观规览计订认让议记许设访证评识诉词试话询该详误说请读谁调负财责败账货质购贴贵费资赚车转轮载辅辑输边达过运还这进远连适选递邮释针钟钮钱银铺链销锁错键长门" +
  "闭问间闸阅队阳陈难静页顶项顺须顿预题额风马驳驻验鹏齐义么于后发干里划准征历汇占签着冲复荐护检轻软岁声习乡书乱亚仪伤伟众伙伞债倾偿储党兴养冻刘剑劝势勋医协卢厂厉县叙叶叹吗吨听呗呜" +
  "咏哑唤喷嘱园圆坛坚块垒垦堕壮壳夹夺奖奥妆妇妈娱婴孙学宁宠宪宫宽宾寝寻寿尔尘尧尽屉届屡岂岗岛峡崭币帅帐帮广庄庆庙弃弥弯彻忆忧怀怜恋恒恳恼悦悬惊惧惨惯愿戏战扑扬扰抛抚拟拢拣拥拧挚挠" +
  "挣挤挥捞损捡捣掷揽摄摆摇摊撑敌敛斋斗斩断旧旷晋晓晕术杀杂杆杨构枪枫栏栖档桥桩梦榄横欢欧残毁毙气汉汤沟没沦沧泪泼泽浅浆浇浊测济浑浓涂涛渐渔渗温湾湿溃滚滨滩潜澜灭灵灾炉炼烂烦烧烛焕" +
  "炖爱牵牺犹犷狮狭狱猎猪献玛环琐画畅疗疮疯痒瘫皱盏盐监盘矫矶矿砚硕碍碱礼祷祸秃秆秽穷窃窍窑窜窝窥竖竞笃笋笺笼筑筝篮篱紧纤纪纬纭纱纲纵纸纹纺纽练绅绊绍绎绒绕绘绚绞绢绣绩绪绮绰绳绵绷" +
  "综绽缀缄缅缆缉缔缕缘缚缝缠缤缩缭缮罚罢翘职聪肃肠肤肾肿胀胁胆胜胶脉脏脐脓脚脱脸腊腻腾舆舰舱艰艳芜芦苇苍苏苹茎茧荚荞荟荠荡荣荤莱莲萝萤萦萧萨葱蒋蔷蔼蕴虏虑虚虫虽虾蚀蚁蚂蚕蛮蜗蝇衬" +
  "袄袜裆裤褛觅视觉触誉讥讨训讯讲讳论讼讽诀诈诊译诗诚诛诞诬语诱诵诸诺课谅谈谊谋谍谎谏谐谓谕谘谚谜谢谣谤谦谨谬谱谴贝贞贡贤贩贪贫贬贮贯贰贱贷贸贺贼贾贿赁赂赈赊赋赌赎赏赐赔赖赘赛赞赠" +
  "赡赢趋跃践跷踪蹒躯轧轨轩轭轰轴较辆辈辉辐辕辖辗辙辞辩辽迁迈违迟迹逊逻遗遥邓邬邹邻郑酝酱酿鉴钉钓钙钝钞钠钢钥钦钧钩钳钻钾铀铁铃铅铜铝铠铡铭铲铸锂锅锈锋锌锐锚锡锣锤锥锦锭锯锰锻镀镁" +
  "镇镜镶闩闪闯闲闷闹闻阀阁阴阵阶际陆陇险随隐隶鸡雾霉韦韧韩顷顽顾领颇频颓颖颗颜颤飘飞饥饭饮饰饱饲饶饺饼馄馅馆馈馒驭驮驯驰驱驶驼骂骄骆骇骏骑骗骚骤髅鲁鲜鲤鲸鸟鸣鸥鸦鸭鸯鸳鸽鸿鹅鹉鹊" +
  "鹤麦黄齿龄龙龟游范";
const T =
  "與專業東丟兩個為樂買爭虧僅從們價優會傳體餘側兒關內冊寫決淨減幾則剛創刪別辦務動勞區華單賣臥衛廳壓廚參雙變號啟員響團圍圖聖壞牆處備夠頭寶實審對導將嘗層屬師帶並庫應廢開異張強歸當錄" +
  "徑態總惡戶執掃搶報攔擇掛擋換據數無時顯曬暫機權條來極櫃標樹樣樓檻櫥潔灑瀏潤漲滿濾燈點熱狀獨現電蓋盜碼磚礎確離種積稱稅穩筆篩簡類糾紅約級純納紛線組細織終經綁結給絡絕統繼續維綠緩編" +
  "繳網羅聯腦藝節獲營藍補裝見觀規覽計訂認讓議記許設訪證評識訴詞試話詢該詳誤說請讀誰調負財責敗帳貨質購貼貴費資賺車轉輪載輔輯輸邊達過運還這進遠連適選遞郵釋針鐘鈕錢銀鋪鏈銷鎖錯鍵長門" +
  "閉問間閘閱隊陽陳難靜頁頂項順須頓預題額風馬駁駐驗鵬齊義麼於後發幹裡劃準徵歷匯佔簽著衝復薦護檢輕軟歲聲習鄉書亂亞儀傷偉眾夥傘債傾償儲黨興養凍劉劍勸勢勳醫協盧廠厲縣敘葉嘆嗎噸聽唄嗚" +
  "詠啞喚噴囑園圓壇堅塊壘墾墮壯殼夾奪獎奧妝婦媽娛嬰孫學寧寵憲宮寬賓寢尋壽爾塵堯盡屜屆屢豈崗島峽嶄幣帥帳幫廣莊慶廟棄彌彎徹憶憂懷憐戀恆懇惱悅懸驚懼慘慣願戲戰撲揚擾拋撫擬攏揀擁擰摯撓" +
  "掙擠揮撈損撿搗擲攬攝擺搖攤撐敵斂齋鬥斬斷舊曠晉曉暈術殺雜桿楊構槍楓欄棲檔橋樁夢欖橫歡歐殘毀斃氣漢湯溝沒淪滄淚潑澤淺漿澆濁測濟渾濃塗濤漸漁滲溫灣濕潰滾濱灘潛瀾滅靈災爐煉爛煩燒燭煥" +
  "燉愛牽犧猶獷獅狹獄獵豬獻瑪環瑣畫暢療瘡瘋癢癱皺盞鹽監盤矯磯礦硯碩礙鹼禮禱禍禿稈穢窮竊竅窯竄窩窺豎競篤筍箋籠築箏籃籬緊纖紀緯紜紗綱縱紙紋紡紐練紳絆紹繹絨繞繪絢絞絹繡績緒綺綽繩綿繃" +
  "綜綻綴緘緬纜緝締縷緣縛縫纏繽縮繚繕罰罷翹職聰肅腸膚腎腫脹脅膽勝膠脈髒臍膿腳脫臉臘膩騰輿艦艙艱艷蕪蘆葦蒼蘇蘋莖繭莢蕎薈薺蕩榮葷萊蓮蘿螢縈蕭薩蔥蔣薔藹蘊虜慮虛蟲雖蝦蝕蟻螞蠶蠻蝸蠅襯" +
  "襖襪襠褲褸覓視覺觸譽譏討訓訊講諱論訟諷訣詐診譯詩誠誅誕誣語誘誦諸諾課諒談誼謀諜謊諫諧謂諭諮諺謎謝謠謗謙謹謬譜譴貝貞貢賢販貪貧貶貯貫貳賤貸貿賀賊賈賄賃賂賑賒賦賭贖賞賜賠賴贅賽贊贈" +
  "贍贏趨躍踐蹺蹤蹣軀軋軌軒軛轟軸較輛輩輝輻轅轄輾轍辭辯遼遷邁違遲跡遜邏遺遙鄧鄔鄒鄰鄭醞醬釀鑑釘釣鈣鈍鈔鈉鋼鑰欽鈞鉤鉗鑽鉀鈾鐵鈴鉛銅鋁鎧鍘銘鏟鑄鋰鍋銹鋒鋅銳錨錫鑼錘錐錦錠鋸錳鍛鍍鎂" +
  "鎮鏡鑲閂閃闖閒悶鬧聞閥閣陰陣階際陸隴險隨隱隸雞霧黴韋韌韓頃頑顧領頗頻頹穎顆顏顫飄飛飢飯飲飾飽飼饒餃餅餛餡館饋饅馭馱馴馳驅駛駝罵驕駱駭駿騎騙騷驟髏魯鮮鯉鯨鳥鳴鷗鴉鴨鴦鴛鴿鴻鵝鵡鵲" +
  "鶴麥黃齒齡龍龜遊範";

/**
 * 🔴 **两串长度必须一致，否则整张表往后错一位，转出来全是乱字。**
 *    这个错误一旦发生是**整站范围**的，而且很难一眼看出来
 *    （只是某些字变成了别的字），所以在模块加载时就炸掉，别等用户发现。
 */
if (S.length !== T.length) {
  throw new Error(`简繁映射表长度不一致：简 ${S.length} / 繁 ${T.length}`);
}

const CHAR_MAP = new Map<string, string>();
for (let i = 0; i < S.length; i += 1) CHAR_MAP.set(S[i]!, T[i]!);

const PHRASE_MAP = new Map(PHRASES);
const PHRASE_MAX = Math.max(...PHRASES.map(([s]) => s.length));

/**
 * 简 → 繁。
 *
 * 🔴 **词和字必须在同一遍扫描里分胜负，不能"先整体换词、再整体换字"。**
 *
 *    分两遍的话，词表里那些**故意保持原样**的条目会被第二遍拆掉：
 *    「皇后」先按词转成「皇后」，第二遍逐字又把「后」换成「後」，
 *    出来是「皇後」。这正是单测抓到的第一个错。
 *
 *    所以这里是**最长匹配优先的单遍扫描**：每个位置先试词（长的先试），
 *    命中就整段吐出去并跳过，没命中才按单字换 —— 词一旦命中就不会再被动。
 *
 * ⚠️ 不含中文的直接返回：页面上大量的金额、订单号、时间走这条捷径。
 */
export function toHant(text: string): string {
  if (!/[一-鿿]/.test(text)) return text;
  let out = "";
  let i = 0;
  while (i < text.length) {
    let matched = 0;
    for (let len = Math.min(PHRASE_MAX, text.length - i); len >= 2; len -= 1) {
      const to = PHRASE_MAP.get(text.slice(i, i + len));
      if (to !== undefined) {
        out += to;
        matched = len;
        break;
      }
    }
    if (matched) {
      i += matched;
      continue;
    }
    const ch = text[i]!;
    out += CHAR_MAP.get(ch) ?? ch;
    i += 1;
  }
  return out;
}

/* ─────────────────────── 挂到页面上 ─────────────────────── */

/** 这些标签里的文字不能动。 */
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "PRE"]);

/** 这几个属性是给人看的文字，也要转。⚠️ `value` 不在里面 —— 那是用户的输入。 */
const TEXT_ATTRS = ["placeholder", "title", "aria-label"];

function skip(node: Node): boolean {
  let el = node.parentElement;
  while (el) {
    if (SKIP_TAGS.has(el.tagName)) return true;
    if (el.isContentEditable) return true;
    /** 逃生舱：给不该被转的内容打 `data-no-hant`（比如原样展示的英文/代码）。 */
    if (el.hasAttribute("data-no-hant")) return true;
    el = el.parentElement;
  }
  return false;
}

function convertTree(root: Node) {
  if (root.nodeType === Node.TEXT_NODE) {
    if (skip(root)) return;
    const next = toHant(root.nodeValue ?? "");
    /** ⚠️ 只在真的变了才写回：无谓的写会再触发一轮 MutationObserver。 */
    if (next !== root.nodeValue) root.nodeValue = next;
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE) return;

  const el = root as Element;
  for (const attr of TEXT_ATTRS) {
    const v = el.getAttribute(attr);
    if (v) {
      const next = toHant(v);
      if (next !== v) el.setAttribute(attr, next);
    }
  }

  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const texts: Text[] = [];
  while (walker.nextNode()) texts.push(walker.currentNode as Text);
  for (const t of texts) {
    if (skip(t)) continue;
    const next = toHant(t.nodeValue ?? "");
    if (next !== t.nodeValue) t.nodeValue = next;
  }

  for (const attr of TEXT_ATTRS) {
    for (const child of el.querySelectorAll(`[${attr}]`)) {
      const v = child.getAttribute(attr);
      if (!v) continue;
      const next = toHant(v);
      if (next !== v) child.setAttribute(attr, next);
    }
  }
}

let observer: MutationObserver | null = null;

/**
 * 打开繁体。
 *
 * 🔴 **转换是幂等的**（繁体字映射不到自己身上），所以 React 每次更新
 *    我们再转一遍完全安全 —— 这也是这套做法能成立的原因。
 *
 * ⚠️ **React 不会跟我们打架**：它写 `nodeValue` 之后不再读回 DOM 比对，
 *    所以我们改完它下次照样按自己的虚拟树更新，我们再转一次即可。
 */
export function enableHant(): () => void {
  if (observer) return disableHant;
  convertTree(document.body);
  observer = new MutationObserver((records) => {
    for (const r of records) {
      if (r.type === "characterData") {
        const n = r.target;
        if (!skip(n)) {
          const next = toHant(n.nodeValue ?? "");
          if (next !== n.nodeValue) n.nodeValue = next;
        }
      } else if (r.type === "attributes") {
        convertTree(r.target as Element);
      } else {
        for (const added of r.addedNodes) convertTree(added);
      }
    }
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: TEXT_ATTRS,
  });
  return disableHant;
}

/**
 * 关掉繁体。
 * ⚠️ **只停观察，不把已经转过的字转回去** —— 逆向转换（繁→简）是另一张表，
 *    而且一简对多繁是不可逆的（「後」和「后」都要变回「后」）。
 *    后台切回简体后刷新一次页面就是干净的简体。
 */
export function disableHant() {
  observer?.disconnect();
  observer = null;
}
